import { AfterViewInit, Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";

import { CustomerService } from "../../../services/local/customer.service";
import { TealiumUtagService } from "../../../tealium/utag.service";

@Component({
  selector: "app-form-confirmation",
  templateUrl: "./form-confirmation.component.html",
  styleUrls: ["form-confirmation.component.scss"],
})
export class FormConfirmationComponent implements OnInit, AfterViewInit {
  icon: string;
  title: string;

  formGroup: UntypedFormGroup;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private tealiumUtagService: TealiumUtagService,
  ) {}

  ngOnInit() {
    this.icon = "./assets/images/icon-document.svg";
    this.title = "Los documentos fueron cargados";

    this.initForm();
  }

  ngAfterViewInit(): void {
    this.tealiumUtagService.view({
      tealium_event: "page_view",
      page_path: document.location.pathname,
    });
  }

  initForm() {
    this.formGroup = new UntypedFormGroup({});
  }

  continue() {
    this.tealiumUtagService.link({
      tealium_event: "click",
      event_category: "carga_documentos",
      event_label: "salir",
      userId: this.tealiumUtagService.managementUserId(),
    });
    setTimeout(() => {
      this.router.navigate(["welcome"]);
    }, 500);
  }
}
